import { MUTATION_GROUP } from './constants';
import type { JiraWikiTextFieldInput } from './types';

export const mutateTextAreaField = (
	value: string,
	fieldId: string,
): JiraWikiTextFieldInput | null => ({
	fieldId,
	mutationGroup: MUTATION_GROUP,
	richText: {
		wikiText: value,
	},
});
